import { useEffect } from 'react';
import { AppWatch } from '@wajeez/wajeez.microservices';
import {
  useAppwatchSelector,
  useAppwatchDispatch,
  PaymentAnalysisActions,
} from '@wajeez-web/stores/appwatch';
import { Card } from '@wajeez-web/components/ui';
import { ChartDisplay } from '@wajeez-web/components/ui';
import { ChartHeader } from '../ChartHeader';
import { ChartsProps } from '../types';
import { Select } from 'antd';

const DailyBreakdownByPurchaseSurceChartFiltered = ({ dates }: ChartsProps) => {
  const dispatch = useAppwatchDispatch();
  const {
    dailyBreakdownByPurchaseSurceFiltered,
    dailyBreakdownByPurchaseSurceFilteredStatus,
  } = useAppwatchSelector((c) => c.paymentAnalysis);

  useEffect(() => {
    dispatch(
      PaymentAnalysisActions.getDailyBreakdownByPurchesFilteredSourceAsync({
        fromDate: dates[0].toISOString(),
        toDate: dates[1].toISOString(),
        purchaseSourceType: AppWatch.PurchaseSourceType.DCP_WALLET,
      })
    );
  }, [dates]);

  return (
    <div className="col-span-2">
      {' '}
      <Card>
        <div className="space-y-2">
          <div className="flex flex-row justify-between">
            <ChartHeader
              title="daily Breakdown By Purchase Surce"
              dates={dates}
            />
          </div>

          <ChartDisplay
            loading={dailyBreakdownByPurchaseSurceFilteredStatus === 'loading'}
            chartType="bar"
            xAxistype="datetime"
            chart={{
              type: 'bar',

              stacked: true,
            }}
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            seriesData={Array.from(
              new Set(
                dailyBreakdownByPurchaseSurceFiltered.map(
                  (d) => d.purchase_Source_Type || ''
                )
              )
            )?.map((element) => ({
              name: element,
              data: dailyBreakdownByPurchaseSurceFiltered
                .filter((d) => d.purchase_Source_Type === element)
                .map((d) => ({
                  y: d.count || '',

                  x: d.startDate || '',
                })),
            }))}
          />
        </div>
      </Card>
    </div>
  );
};

export default DailyBreakdownByPurchaseSurceChartFiltered;
